export var formattedDate = function (data) {
    if (data === undefined)
        return "undefined";
    if (Number.isNaN(Date.parse(data)))
        return "NA";
    var options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    };
    return new Date(data).toLocaleDateString("es-ES", options);
};
export var formattedDateWithTime = function (data) {
    if (data === undefined)
        return "undefined";
    if (Number.isNaN(Date.parse(data)))
        return "NA";
    var date = new Date(data);
    return date.toISOString().split("T")[0] + "T00:00:00.000Z";
};
export var formattedDateTime = function (data) {
    if (data === undefined)
        return "undefined";
    if (Number.isNaN(Date.parse(data)))
        return "NA";
    var options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
    };
    return new Date(data).toLocaleString("es-ES", options);
};
export var newFormattedDate = function (data, monthYearOnly, separator) {
    if (separator === void 0) { separator = "-"; }
    if (!data)
        return "";
    var year, month, day;
    if (data.includes("/")) {
        var _a = data.split("/"), first = _a[0], second = _a[1], y = _a[2];
        var firstNum = parseInt(first, 10);
        var secondNum = parseInt(second, 10);
        year = parseInt(y, 10);
        // El primer número no puede ser mes (>12) => es DD/MM/YYYY sin dudas.
        // El segundo número no puede ser mes (>12) => es MM/DD/YYYY sin dudas.
        // Si ambos son <=12 (ambiguo), asumimos DD/MM/YYYY por ser la
        // convención que usa el resto de la app (mismo formato de salida).
        if (secondNum > 12) {
            month = firstNum - 1;
            day = secondNum;
        }
        else {
            day = firstNum;
            month = secondNum - 1;
        }
    }
    else {
        // Formato "YYYY-MM-DD"
        var _b = data.split("-"), y = _b[0], m = _b[1], d = _b[2];
        year = parseInt(y, 10);
        month = parseInt(m, 10) - 1;
        day = parseInt(d, 10);
    }
    if (isNaN(year) || isNaN(month) || isNaN(day))
        return data;
    var date = new Date(Date.UTC(year, month, day));
    var formattedDay = ("0" + date.getUTCDate()).slice(-2);
    var formattedMonth = ("0" + (date.getUTCMonth() + 1)).slice(-2);
    var formattedYear = date.getUTCFullYear();
    if (monthYearOnly) {
        return "".concat(formattedMonth).concat(separator).concat(formattedYear);
    }
    return "".concat(formattedDay).concat(separator).concat(formattedMonth).concat(separator).concat(formattedYear);
};
export var newFormattedDateYYMMDD = function (data) {
    if (data) {
        var parts = data.split("-");
        if (parts.length === 3) {
            var day = parts[0];
            var month = parts[1];
            var year = parts[2];
            var isoFormattedDate = "".concat(year, "-").concat(month, "-").concat(day);
            var date = new Date(isoFormattedDate);
            if (!isNaN(date.getTime())) {
                return isoFormattedDate;
            }
            else {
                return "";
            }
        }
        else {
            return "";
        }
    }
    else {
        return "";
    }
};
export var formattedDateYYMMDD = function (data) {
    if (data === undefined)
        return "undefined";
    if (Number.isNaN(Date.parse(data)))
        return "NA";
    // Convertir la fecha a formato ISO y extraer solo la parte de la fecha
    return new Date(data).toISOString().split("T")[0];
};
export var formattedDateWithHour = function (data) {
    if (!data)
        return "";
    if (Number.isNaN(Date.parse(data)))
        return "NA";
    return new Date(data)
        .toLocaleString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
        timeZone: "UTC",
    })
        .replace(",", "")
        .replace(/\//g, "-");
};
